import * as React from 'react';

export default function Escape() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20.386} height={23.396}>
      <path
        data-name="Path 4035"
        d="M1.82.003A1.833 1.833 0 0 0 0 1.823v19.754a1.833 1.833 0 0 0 1.82 1.82h8.319a.78.78 0 1 0 0-1.56H1.82a.244.244 0 0 1-.26-.26V1.82a.244.244 0 0 1 .26-.26h8.319a.78.78 0 1 0 0-1.56Z"
        fill="#d9d9d9"
      />
      <path
        data-name="Path 4015"
        d="m12.925 4.237 6.876 6.106a1.852 1.852 0 0 1 0 2.706l-6.876 6.106 3.261-6.526-10.049-.465c-.371 0-.673-.209-.673-.466s.3-.466.673-.466l10.049-.465Z"
        fill="#d9d9d9"
        fillRule="evenodd"
      />
    </svg>
  );
}
